// extracted by mini-css-extract-plugin
export var activeFilterButton = "_sg-c";
export var backButton = "_sg-4";
export var backIcon = "_sg-5";
export var chevronShortcut = "_sg-6";
export var container = "_sg-1";
export var editor = "_sg-8";
export var editorWrapper = "_sg-7";
export var prefix = "_sg-2";
export var searchIcon = "_sg-3";
export var suffix = "_sg-9";
export var suffixContent = "_sg-a";
export var suffixText = "_sg-b";
export var wrapper = "_sg-0";